module.exports = __webpack_public_path__ + "static/img/top.7ab1db42.png";